import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=256580c5&scoped=true"
import script from "./videoList.vue?vue&type=script&lang=js"
export * from "./videoList.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/course/videoList.css?vue&type=style&index=0&id=256580c5&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256580c5",
  null
  
)

export default component.exports